import { find, toPairs } from 'ramda';

import { capitalizeFirstLetter } from './extra';

export const countries = {
  FINLAND: 'fi',
  DENMARK: 'dk',
  SWEDEN: 'se',
  NORWAY: 'no',
  GERMANY: 'de',
  AUSTRIA: 'at',
  SWITZERLAND: 'ch',
};

export const getFullCountryName = (countryCode) => {
  const matchEntry = find(([, v]) => v === countryCode, toPairs(countries));

  if (!matchEntry) {
    return null;
  }

  return capitalizeFirstLetter(matchEntry[0].toLowerCase());
};
